import { render, staticRenderFns } from "./Registrations.vue?vue&type=template&id=5979a1b6"
import script from "./Registrations.vue?vue&type=script&lang=js"
export * from "./Registrations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports